import React from "react";
import styled from "styled-components";

const StyledFormTitle = styled.div`
  font-size: ${({ theme, size }) => (size ? size : theme.fontSize.slarge)};
  font-weight: 600;
  color: ${({ theme }) => theme.fontColor};
  text-align: center;
  padding-bottom: 10px;
`;

const FormTitle = ({ size, children }) => {
  return <StyledFormTitle size={size}>{children}</StyledFormTitle>;
};

export default FormTitle;

export { StyledFormTitle };
